<template>
  <div
    id="kt_modal_bloqueio_licenca_editar"
    ref="kt_modal_bloqueio_licenca_editar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header p-3 bg-light">
          <h4 class="modal-title" v-if="this.id === 0">
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Adicionar Bloqueio
          </h4>
          <h4 class="modal-title" v-else>
            <img
              src="media/icons/duotune/general/gen055.svg"
              class="me-2"
            />Editar Bloqueio
          </h4>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <div class="row">
            <div
              v-if="this.errosGerais && this.errosGerais.Message"
              class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
            >
              <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
                <inline-svg src="media/icons/duotune/general/gen044.svg" />
              </span>
              <div class="d-flex flex-stack flex-grow-1">
                <div class="fw-bold">
                  <h4 class="text-gray-800 fw-bolder">Aviso</h4>
                  <div class="fs-6 text-gray-600">
                    {{ this.errosGerais.Message }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-4 col-xxl-4 fv-row mb-2"
            >
              <label class="required form-label">Para</label>
              <select class="form-select" aria-label="para" v-model="this.para">
                <option v-for="tipo in tiposPara" :key="tipo" :value="tipo">
                  {{ tipo }}
                </option>
              </select>
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["para"] }}
              </div>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-6 col-xl-8 col-xxl-8 mb-4">
              <label for="txtPara" class="required form-label">{{
                this.para
              }}</label>
              <div class="input-group">
                <input
                  type="text"
                  id="txtPara"
                  class="form-control"
                  :value="
                    this.idPara > 0 ? this.idPara + ' - ' + this.nomePara : ''
                  "
                  readonly
                />
                <button
                  class="input-group-text"
                  @click.prevent="modalSelecionarPara()"
                >
                  <span class="svg-icon svg-icon-2">
                    <inline-svg src="media/icons/duotune/general/gen004.svg" />
                  </span>
                </button>
              </div>
              <div class="fv-plugins-message-container invalid-feedback">
                {{ errosValidacao["id_revenda"] }}
              </div>
            </div>
          </div>
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 fv-row mb-4"
            >
              <label class="form-label">Motivo bloqueio</label>
              <textarea
                :id="`txtMotivo`"
                class="form-control mb-2"
                maxlength="1500"
                style="height: 130px"
                v-model="this.bloqueioLicenca.motivo"
              />
              <div class="text-end text-muted fs-7">
                {{
                  this.bloqueioLicenca.motivo
                    ? this.bloqueioLicenca.motivo.length
                    : "0"
                }}/1500 caracteres
              </div>
              <div class="fv-plugins-message-container invalid-feedback m-0">
                {{ errosValidacao["motivo"] }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer d-flex justify-content-end">
          <button
            class="btn btn-danger svg-icon-white me-2 mb-2"
            @click="cancelar()"
          >
            <span class="svg-icon svg-icon-1">
              <inline-svg
                src="media/icons/duotune/arrows/arr015.svg"
                class="me-2"
              />Cancelar
            </span>
          </button>
          <button
            class="btn btn-success svg-icon-white mb-2"
            :id="`btnConfirmar`"
            @click="confirmar()"
            v-bind:data-kt-indicator="this.loading ? 'on' : 'off'"
          >
            <span class="indicator-progress">
              <span
                class="spinner-border spinner-border-sm align-middle ms-1"
              ></span>
              Aguarde...
            </span>
            <span class="svg-icon svg-icon-1" v-if="!this.loading">
              <inline-svg
                src="media/icons/duotune/arrows/arr016.svg"
                class="me-2"
              />Confirmar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalEditarBloqueioLicenca'"
    :mensagem="this.mensagemLoading"
    v-if="this.loadingBloqueioLicenca === true"
  ></LoadingModal>
  <RevendaModal
    v-if="exibirModalRevenda"
    @exibirModalRevenda="modalRevenda"
    @selecionarRevenda="selecionarRevenda"
  ></RevendaModal>
  <DistribuidorModal
    v-if="exibirModalDistribuidor"
    @exibirModalDistribuidor="modalDistribuidor"
    @selecionarDistribuidor="selecionarDistribuidor"
  ></DistribuidorModal>
  <DistribuidorMasterModal
    v-if="exibirModalDistribuidorMaster"
    @exibirModalDistribuidorMaster="modalDistribuidorMaster"
    @selecionarDistribuidorMaster="selecionarDistribuidorMaster"
  ></DistribuidorMasterModal>
  <EmpresasModal
    v-if="exibirEmpresas"
    @exibirModalEmitente="modalEmpresas"
    @selecionarEmitente="selecionarEmitente"
  ></EmpresasModal>
</template>

<script>
import { useToast } from "vue-toastification";
import {
  hideModal,
  getOrCreateInstanceModal,
  hideModalId,
} from "@/core/helpers/dom";
import { mapState } from "vuex";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";
const toast = useToast();
import RevendaModal from "@/views/revenda/revenda/RevendaModal.vue";
import DistribuidorModal from "@/views/revenda/distribuidor/DistribuidorModal.vue";
import DistribuidorMasterModal from "@/views/revenda/distribuidormaster/DistribuidorMasterModal.vue";
import EmpresasModal from "@/views/empresas/EmpresasModal.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

const bloqueioLicencaInicializado = {
  id: 0,
  motivo: "",
  id_usuario: 0,
  id_emitente: null,
  id_distribuidor_master: null,
  id_distribuidor: null,
  id_revenda: null,
  id_licenca_recebivel: null,
  Emitente: {},
  DistribuidorMaster: {},
  Distribuidor: {},
  Revenda: {},
  LicencaRecebivel: {},
};

export default {
  emits: [
    "exibirEditarBloqueioLicencaModal",
    "confirmarEditarBloqueioLicencaModal",
  ],
  components: {
    LoadingModal,
    RevendaModal,
    DistribuidorModal,
    DistribuidorMasterModal,
    EmpresasModal,
  },
  computed: {
    ...mapState("auth", ["user"]),
  },
  props: {
    id: { type: Number, required: true },
  },
  methods: {
    async confirmar() {
      this.errosValidacao = [];
      this.loading = true;
      if ((await this.validar()) === true) {
        if (this.id <= 0) {
          try {
            this.bloqueioLicenca.Emitente = null;
            this.bloqueioLicenca.Revenda = null;
            this.bloqueioLicenca.Distribuidor = null;
            this.bloqueioLicenca.DistribuidorMaster = null;
            this.bloqueioLicenca.LicencaRecebivel = null;

            var ret = await this.$store.dispatch(
              "bloqueioLicenca/postBloqueioLicenca",
              this.bloqueioLicenca
            );
            if (ret.Success === true) {
              toast.success("Bloqueio adicionado com sucesso!", {
                timeout: 3000,
              });
              this.$emit("confirmarEditarBloqueioLicencaModal", false);
              hideModal(this.$refs.kt_modal_bloqueio_licenca_editar);
            }
          } catch (error) {
            this.errosValidacao = error;
          }
        } else {
          try {
            this.bloqueioLicenca.Emitente = null;
            this.bloqueioLicenca.Revenda = null;
            this.bloqueioLicenca.Distribuidor = null;
            this.bloqueioLicenca.DistribuidorMaster = null;
            this.bloqueioLicenca.LicencaRecebivel = null;

            let retPut = await this.$store.dispatch(
              "bloqueioLicenca/putBloqueioLicenca",
              this.bloqueioLicenca
            );
            if (retPut.Success === true) {
              toast.success("Bloqueio atualizado com sucesso!", {
                timeout: 3000,
              });
              this.$emit("confirmarEditarBloqueioLicencaModal", false);
              hideModal(this.$refs.kt_modal_bloqueio_licenca_editar);
            }
          } catch (error) {
            this.errosValidacao = error;
          }
        }
      } else {
        await this.$swal.showInvalidAlert(
          "Verifique os avisos antes de prosseguir!"
        );
      }
      this.loading = false;
    },
    async validar() {
      this.errosGerais = [];
      if (this.idPara <= 0) {
        this.errosGerais.Message =
          "É necessário informar para quem será destinado o bloqueio";
        return false;
      }

      if (!this.bloqueioLicenca) {
        this.errosGerais.Message = "O bloqueio não foi informado";
        return false;
      } else if (this.bloqueioLicenca.motivo.length.trim <= 0) {
        this.errosGerais.Message = "O motivo do bloqueio deve ser informado!";
        return false;
      } else if (this.bloqueioLicenca.motivo.length.trim <= 15) {
        this.errosGerais.Message =
          "O motivo do bloqueio deve ter no mínimo 15 caracteres!";
        return false;
      }

      return true;
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    cancelar() {
      hideModal(this.$refs.kt_modal_bloqueio_licenca_editar);
      this.$emit("exibirEditarBloqueioLicencaModal", false);
    },
    async exibirModalLoading(exibir, callback) {
      if (exibir === true) {
        this.loadingBloqueioLicenca = true;
        getOrCreateInstanceModal(
          "loadingModalEditarBloqueioLicenca",
          /*open*/ null,
          /*close*/ null
        );
      } else {
        hideModalId("loadingModalEditarBloqueioLicenca", () => {
          this.loadingBloqueioLicenca = false;
          this.$nextTick(() => {
            if (callback) {
              callback();
            }
          });
        });
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    modalSelecionarPara() {
      if (this.para === "Empresa") {
        this.modalEmpresas(true);
      } else if (this.para === "Revenda") {
        this.modalRevenda(true);
      } else if (this.para === "Distribuidor") {
        this.modalDistribuidor(true);
      } else if (this.para === "Distribuidor Master") {
        this.modalDistribuidorMaster(true);
      }
    },
    limparParaSelecionado() {
      this.bloqueioLicenca.id_emitente = null;
      this.bloqueioLicenca.Emitente = {};
      this.bloqueioLicenca.id_revenda = null;
      this.bloqueioLicenca.Revenda = {};
      this.bloqueioLicenca.id_distribuidor = null;
      this.bloqueioLicenca.Distribuidor = {};
      this.bloqueioLicenca.id_distribuidor_master = null;
      this.bloqueioLicenca.DistribuidorMaster = {};
    },
    modalEmpresas(exibir) {
      this.exibirEmpresas = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_empresas_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarEmpresas");
          },
          /*close*/ () => {
            this.modalEmpresas(false);
          }
        );
      }
    },
    selecionarEmitente(emitente) {
      this.limparParaSelecionado();
      this.bloqueioLicenca.id_emitente = emitente.id;
      this.bloqueioLicenca.Emitente = emitente;
      this.idPara = emitente.id;
      this.nomePara = emitente.nome;
      this.motivoSetFocus();
    },
    modalRevenda(exibir) {
      this.exibirModalRevenda = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_revenda_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisar");
          },
          /*close*/ () => {
            this.modalRevenda(false);
          }
        );
      }
    },
    selecionarRevenda(revenda) {
      this.limparParaSelecionado();
      this.bloqueioLicenca.id_revenda = revenda.id;
      this.bloqueioLicenca.Revenda = revenda;
      this.idPara = revenda.id;
      this.nomePara = revenda.nome;
      this.motivoSetFocus();
    },
    modalDistribuidor(exibir) {
      this.exibirModalDistribuidor = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_distribuidor_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisar");
          },
          /*close*/ () => {
            this.modalDistribuidor(false);
          }
        );
      }
    },
    selecionarDistribuidor(distribuidor) {
      this.limparParaSelecionado();
      this.bloqueioLicenca.id_distribuidor = distribuidor.id;
      this.bloqueioLicenca.Distribuidor = distribuidor;
      this.idPara = distribuidor.id;
      this.nomePara = distribuidor.nome;
      this.motivoSetFocus();
    },
    modalDistribuidorMaster(exibir) {
      this.exibirModalDistribuidorMaster = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_distribuidor_master_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisar");
          },
          /*close*/ () => {
            this.modalDistribuidorMaster(false);
          }
        );
      }
    },
    selecionarDistribuidorMaster(distribuidorMaster) {
      this.limparParaSelecionado();
      this.bloqueioLicenca.id_distribuidor_master = distribuidorMaster.id;
      this.bloqueioLicenca.DistribuidorMaster = distribuidorMaster;
      this.idPara = distribuidorMaster.id;
      this.nomePara = distribuidorMaster.nome;
      this.motivoSetFocus();
    },
    motivoSetFocus() {
      setTimeout(() => {
        this.nextFocus(`txtMotivo`);
      }, 300);
    },
    async carregarTiposPara() {
      if (this.user.User.TipoUsuario.tipo === "Administrador") {
        this.tiposPara.push(
          "Empresa",
          "Revenda",
          "Distribuidor",
          "Distribuidor Master"
        );
      } else if (this.user.User.TipoUsuario.tipo === "Distribuidor Master") {
        this.tiposPara.push("Empresa", "Revenda", "Distribuidor");
      } else if (this.user.User.TipoUsuario.tipo === "Distribuidor") {
        this.tiposPara.push("Empresa", "Revenda");
      } else if (this.user.User.TipoUsuario.tipo === "Revenda") {
        this.tiposPara.push("Empresa");
      }
    },
  },
  async mounted() {
    this.loading = true;
    this.errosValidacao = [];
    this.errosGerais = [];

    await this.carregarTiposPara();

    if (this.id <= 0) {
      this.bloqueioLicenca = JSON.parse(
        JSON.stringify(bloqueioLicencaInicializado)
      );
    } else {
      try {
        let ret = await this.$store.dispatch(
          "bloqueioLicenca/getBloqueioLicenca",
          this.id
        );

        if (ret.Success === true) {
          this.bloqueioLicenca = ret.Data;
          if (this.bloqueioLicenca.Emitente) {
            this.para = "Empresa";
            this.idPara = this.bloqueioLicenca.Emitente.id;
            this.nomePara = this.bloqueioLicenca.Emitente.nome;
          } else if (this.bloqueioLicenca.Revenda) {
            this.para = "Revenda";
            this.idPara = this.bloqueioLicenca.Revenda.id;
            this.nomePara = this.bloqueioLicenca.Revenda.nome;
          } else if (this.bloqueioLicenca.Distribuidor) {
            this.para = "Distribuidor";
            this.idPara = this.bloqueioLicenca.Distribuidor.id;
            this.nomePara = this.bloqueioLicenca.Distribuidor.nome;
          } else if (this.bloqueioLicenca.DistribuidorMaster) {
            this.para = "Distribuidor Master";
            this.idPara = this.bloqueioLicenca.DistribuidorMaster.id;
            this.nomePara = this.bloqueioLicenca.DistribuidorMaster.nome;
          }
        }
      } catch (error) {
        console.log(error);
      }
    }

    this.loading = false;
    this.$utils.requestFocus(`txtMotivo`);
  },
  data() {
    return {
      errosGerais: [],
      errosValidacao: [],
      bloqueioLicenca: JSON.parse(JSON.stringify(bloqueioLicencaInicializado)),
      loading: false,
      loadingBloqueioLicenca: false,
      exibirEmpresas: false,
      exibirModalRevenda: false,
      exibirModalDistribuidor: false,
      exibirModalDistribuidorMaster: false,
      tiposPara: [],
      idPara: 0,
      nomePara: "",
      para: "Empresa",
    };
  },
};
</script>

<style></style>
